<template>
  <div>
    <el-dialog 
    width="400px" 
   :visible='addName_visible' 
   :close-on-click-modal='false' 
   :close-on-press-escape='false' 
   :show-close='false'
   @close='close_BankName'
   >
   <el-form :model="bankName_form" label-width="120px" :rules="bankName_rules" ref='bankName'>
    <el-form-item label="银行名称" prop="bankName">
        <el-input placeholder="请输入" v-model="bankName_form.bankName" size="small"></el-input>
    </el-form-item>
   </el-form>
    <template #footer>
            <div style="text-align:center">
                <el-button  @click="close_BankName" size="small" style="width:100px;">取消</el-button>
                <el-button  @click="addBank" size="small"  style="width:100px;background:#269D7B;color:#fff">确定</el-button>
            </div>
    </template>
  </el-dialog>
  </div>
</template>

<script>
import {saveBankName} from '@/api'
export default {
    data(){
        return {
            cid:'',
            bankName_rules:{
                bankName:[{ required: true, message: '请输入银行名称', trigger: 'blur' }],
            },
            bankName_form:{
                bankName:''
            },
            addName_visible:false,
        }
    },
    methods:{
        hanldeOpen(){
            this.addName_visible = true
             this.cid = sessionStorage.getItem('cid');
        },
        close_BankName(){
            this.addName_visible = false
            this.$refs.bankName.clearValidate();
            this.$emit('cancle')
            this.bankName_form.bankName =''
        },
        addBank(){
             this.$refs.bankName.validate(valid=>{
                if(valid){
                    saveBankName({cid:this.cid,name:this.bankName_form.bankName}).then(res=>{
                        if(res.data.code==1){
                            this.$message.success(res.data.msg)
                            this.$emit('bank_tip',this.bankName_form.bankName)
                            this.close_BankName()
                        }else {
                             this.$emit('bank_tip','')    
                        }
                    })
                }else {
                    return false
                }
             })
        },
    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/dialog/addBankName.vue